import { RecurringTransferFrequency, RecurringFrequencyUnit } from '../../../components/TransferFrequency/Types'

export const getFrequencyUnit = (frequency: RecurringTransferFrequency): RecurringFrequencyUnit => {
  switch (frequency) {
    case 'WEEKLY':
      return 'WEEK'
    case 'EVERY_OTHER_WEEK':
      return 'WEEK'
    case 'MONTHLY':
      return 'MONTH'
    case 'EVERY_3_MONTHS':
      return 'MONTH'
    case 'EVERY_6_MONTHS':
      return 'MONTH'
    case 'ANNUALLY':
      return 'MONTH'
  }
}
